/**
 * The two lines a person pastes after minting an agent. Kept out of the
 * component so the modal, the tests, and any future "show me the setup
 * again" screen agree byte-for-byte with mcp_server/README.md.
 */

export const envFileName = (username) => `.env.${username}`;

/** Contents of mcp_server/.env.<agent> — raw value, no quotes. */
export const envFileContents = (token, apiBaseUrl) => {
  const lines = [`MONO_API_TOKEN=${token}`];
  if (apiBaseUrl && !/mono-service/.test(apiBaseUrl)) {
    // Local dev: point the agent at this stack, not production.
    lines.push(`MONO_API_BASE_URL=${apiBaseUrl}`);
  }
  return lines.join("\n") + "\n";
};

/** Claude Code: one server entry per agent, in the LOCAL config. */
export const mcpAddCommand = (username) =>
  `claude mcp add mono-${username} -s local -e MONO_ENV_FILE=${envFileName(
    username,
  )} -- uv run --directory mcp_server python mono_local.py`;

/**
 * The hosted MCP (projects/mcp-hosting): the same tools as the stdio server
 * (docs/mcp-server.md has the count), served from Cloud Run, credential
 * forwarded per request. Derived from the API base
 * URL the same way `envFileContents` decides prod vs local, so a local
 * stack points at compose's `mcp-remote` (:8002) and prod at the service.
 */
export const hostedMcpUrl = (apiBaseUrl) =>
  apiBaseUrl && !/mono-service/.test(apiBaseUrl)
    ? "http://localhost:8002/mcp"
    : "https://mono-mcp-842893731443.us-west1.run.app/mcp";

/**
 * Claude Code, no clone needed. `-s user`: the entry follows the person (or
 * agent) into every directory on that machine — unlike the stdio line,
 * which is `-s local` because its `--directory` is relative to this repo.
 * The name carries a `-hosted` suffix so it never shadows the stdio entry
 * of the same identity (`mono` in the committed .mcp.json, `mono-<agent>`
 * from the line above): Claude Code resolves a name to ONE entry, local
 * scope first.
 *
 * Unlike the env-file line, this one CONTAINS the token — pasting it puts
 * the token in shell history and in ~/.claude.json. Every screen that
 * prints it says so (review S1).
 */
export const hostedServerName = (username) =>
  username ? `mono-${username}-hosted` : "mono-hosted";

export const mcpAddHostedCommand = (serverName, token, apiBaseUrl) =>
  `claude mcp add --transport http ${serverName} -s user ${hostedMcpUrl(
    apiBaseUrl,
  )} --header "Authorization: Token ${token}"`;
